import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  token: null,
  authenticated: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.authenticated = true;
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.authenticated = false;
    },
  },
});

export const { setUser, logout } = authSlice.actions;
export default authSlice.reducer;